import { createAsyncThunk } from '@reduxjs/toolkit';
import * as AlarmsApi from '@sophocles/api/alarms';

export const loadExcessiveAlarms = createAsyncThunk('alarms/loadExcessive', async (siteId, { rejectWithValue }) => {
  try {
    const data = await AlarmsApi.fetchExcessiveAlarmsForSite(siteId);
    return data;
  } catch (e) {
    return rejectWithValue(e.response.data);
  }
});
